export default function ContactDetails() {
  return (
    <div>
      <div className="manor-park-bg bg-image">
        <div className="gap-spacer"></div>
        <div className="page-title top-cap-outlines">
          <h2>Contact</h2>
        </div>

        {/*Start Main Content*/}
        <div className="content-fluid">
          <div className="mb-960-center-container mid-side-outlines mobile-pad-1em">
            <div className="mb-960-col-50p">
              <div className="left-right-padding-1em">
                <h4>Address</h4>
                <p>
                  <a href="https://maps.app.goo.gl/RjUcQgXYQvFVtETj8">
                    <i className="fa-solid fa-location-pin"></i>&nbsp;35 Union
                    Street Morrisville, PA 19067
                  </a>
                  <br />
                  <a href="tel:2152958181">
                    <i className="fa-solid fa-phone"></i>&nbsp;215-295-8181
                  </a>
                  <br />
                  <a href="tel:2157363760">
                    <i className="fa-solid fa-fax"></i>&nbsp;215-736-3760
                    <br />
                  </a>
                </p>
                <h4>Municipal Building Hours</h4>
                <p>
                  Monday - Friday
                  <br />
                  8:00 a.m. to 4:30 p.m.
                </p>
                <h4>Phone, Fax, &amp; Email</h4>
                <p>
                  <a href="tel:2152958181">
                    <i className="fa-solid fa-phone"></i>&nbsp;215-295-8181
                  </a>
                  <br />
                  <a href="tel:2157363760">
                    <i className="fa-solid fa-fax"></i>&nbsp;215-736-3760
                  </a>
                  <br />
                  <a href="mailto:info@morrisvilleboro.org">
                    <i className="fa-solid fa-envelope"></i>
                    &nbsp;info@morrisvilleboro.org
                    <br />
                  </a>
                </p>
              </div>
            </div>
            <div className="mb-960-col-50p">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3046.952013325256!2d-74.77785102354905!3d40.210130368187116!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c159de720ce53f%3A0x17a4b101c3fe727d!2sMorrisville%20Borough%20Hall!5e0!3m2!1sen!2sus!4v1730985580121!5m2!1sen!2sus"
                width="100%"
                height="400px"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
                title="Google Maps Embed Showing Borough Hall Address"
              ></iframe>
            </div>
          </div>

          <div className="mb-960-center-container mid-side-outlines mobile-pad-1em">
            
              <br />
     {/*}
                        <div className='mv_table'>
                            <div className='accordian_content'></div>
                            <table id='simple_table'></table>
                        </div>
                        <script>
                            (function($) {
                                var small_screen_heading = "Title";
                                var data = [{
                                    "Title": "Assistant Secretary",
                                    "Name": "Virginia E. Cyphers",
                                    "E-Mail": "N/A",
                                    "Phone": "<a href=\"" + "tel:2152958181\">" + "<i className=\"fa-solid fa-phone\">" + "</i>&nbsp;215-295-8181</a>",
                                }, {
                                    "Title": "Code Enforcement",
                                    "Name": "Barry Isett<br/> &amp; Associates, Inc.",
                                    "E-Mail": "N/A",
                                    "Phone": "<a href=\"" + "tel:6103980904\">" + "<i className=\"fa-solid fa-phone\">" + "</i>&nbsp;610-398-0904</a>",
                                }, {
                                    "Title": "Engineer",
                                    "Name": "Kurt Schroeder, P.E.<br/>Gilmore &amp; Associates, Inc. ",
                                    "E-Mail": "N/A",
                                    "Phone": "<a href=\"" + "tel:2673376969\">" + "<i className=\"fa-solid fa-phone\">" + "</i>&nbsp;267-337-6969</a>",
                                }, {
                                    "Title": "Fire Chief",
                                    "Name": "John Weiss III",
                                    "E-Mail": "N/A",
                                    "Phone": "<a href=\"" + "tel:2677846536\">" + "<i className=\"fa-solid fa-phone\">" + "</i>&nbsp;267-784-6536</a>",
                                }, {
                                    "Title": "Fire Marshall",
                                    "Name": "Barry Isett<br/>&amp; Associates, Inc.",
                                    "E-Mail": "N/A",
                                    "Phone": "<a href=\"" + "tel:6103980904\">" + "<i className=\"fa-solid fa-phone\">" + "</i>&nbsp;610-398-0904</a>",
                                }, {
                                    "Title": "Manager",
                                    "Name": "James Dillon",
                                    "E-Mail": "<a href=\"" + "mailto:manager@morrisvilleboro.org\">" + "<i className=\"fa-solid fa-envelope\">" + "</i>&nbsp;manager@morrisvilleboro.org</a>",
                                    "Phone": "<a href=\"" + "tel:2152958181\">" + "<i className=\"fa-solid fa-phone\">" + "</i>&nbsp;215-295-8181</a>",
                                }, {
                                    "Title": "Mayor",
                                    "Name": "Gary Wallace",
                                    "E-Mail": "<a href=\"" + "mailto:gwallacemb@outlook.com\">" + "<i className=\"fa-solid fa-envelope\">" + "</i>&nbsp;gwallacemb@outlook.com</a>",
                                    "Phone": "<a href=\"" + "tel:2672410985\">" + "<i className=\"fa-solid fa-phone\">" + "</i>&nbsp;267-241-0985</a>",
                                }, {
                                    "Title": "Police Chief",
                                    "Name": "Rich Ciampa",
                                    "E-Mail": "<a href=\"" + "mailto:r.ciampa@morrisvillepolice.org\">" + "<i className=\"fa-solid fa-envelope\">" + "</i>&nbsp;r.ciampa@morrisvillepolice.org</a>",
                                    "Phone": "<a href=\"" + "tel:2152958112\">" + "<i className=\"fa-solid fa-phone\">" + "</i>&nbsp;215-295-8112</a>",
                                }, {
                                    "Title": "Public Works<br/>Superintendent",
                                    "Name": "John Later",
                                    "E-Mail": "N/A",
                                    "Phone": "<a href=\"" + "tel:2152958181\">" + "<i className=\"fa-solid fa-phone\">" + "</i>&nbsp;215-295-8181</a>",
                                }, {
                                    "Title": "Solicitor",
                                    "Name": "Randall C. Flager, Esq.<br/>Flager &amp; Associates, PC",
                                    "E-Mail": "N/A",
                                    "Phone": "<a href=\"" + "tel:2159535200\">" + "<i className=\"fa-solid fa-phone\">" + "</i>&nbsp;215-953-5200</a>",
                                }, {
                                    "Title": "Tax Collector",
                                    "Name": "Kathryn Schell",
                                    "E-Mail": "<a href=\"" + "mailto:katie0179@aol.com\">" + "<i className=\"fa-solid fa-envelope\">" + "</i>&nbsp;katie0179@aol.com</a>",
                                    "Phone": "<a href=\"" + "tel:2152950179\">" + "<i className=\"fa-solid fa-phone\">" + "</i>&nbsp;215-295-0179</a>",
                                }];
                                for (var i = 0; i < data.length; i++) {
                                    var accordianhtml = "<button className='accordion'>" + data[i][small_screen_heading] + "<span className='arrow rarrow'>&#8594;</span><span className='arrow darrow'>&#8595;</span></button><div className='panel'><p><table className='accordian_table'>";
                                    var table_row = null;
                                    var table_header = null;
                                    for (var key in data[i]) {
                                        accordianhtml = accordianhtml + "<tr><th>" + key + "</th><td>" + data[i][key] + "</td></tr>";
                                        if (i === 0 && true) {
                                            table_header = table_header + "<th>" + key + "</th>";
                                        }
                                        table_row = table_row + "<td>" + data[i][key] + "</td>";
                                    }
                                    if (i === 0 && true) {
                                        table_header = "<tr>" + table_header + "</tr>";
                                        $(".mv_table #simple_table").append(table_header);
                                    }
                                    table_row = "<tr>" + table_row + "</tr>";
                                    $(".mv_table #simple_table").append(table_row);
                                    accordianhtml = accordianhtml + "</table></p></div>";
                                    $(".mv_table .accordian_content").append(accordianhtml);
                                }
                                $(".mv_table .accordion").click(function() {
                                    $(".panel").slideUp();
                                    $('.rarrow').show();
                                    $('.darrow').hide();
                                    if (!$(this).hasClass("active")) {
                                        $(".mv_table .accordion").each(function() {
                                            $(this).removeClass('active');
                                        });
                                        $(this).addClass('active');
                                        $(this).next().slideDown();
                                        $(this).find('.rarrow').hide();
                                        $(this).find('.darrow').show();
                                    } else {
                                        $(".mv_table .accordion").each(function() {
                                            $(this).removeClass('active');
                                        });
                                    }
                                });
                            })(jQuery);

                        </script>
                        */}
            </div>
          
          {/*Panel End*/}

          {/*Accordian End*/}
        </div>
        <div className="page-footer bottom-cap-outlines">&nbsp;</div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
      </div>
    </div>
  );
}
